import store from '../store/store';
import { getSelectedPacsConfig } from './pacsSelectorConfig';

const RAIMV7_PREFIX = 'raimV7:';
const DICOMWEB_PREFIX = 'dicomweb:';
const WADO_RS_PREFIX = 'wadors:';
const WADO_URI_PREFIX = 'wadouri:';
const MY_WADO_URI_PREFIX = 'mywadouri:';
const MY_WADO_RS_PREFIX = 'mywadors:';

export const RAIMV7_SERVER_TYPE = 'raimV7';
export const DCM4CHEE_SERVER_TYPE = 'dcm4chee';

export const WADO_RS_WEB_SERVICE_TYPE = 'WADO-RS';
export const WADO_URI_WEB_SERVICE_TYPE = 'WADO-URI';

export default function useServerConfig({ lazy }) {
  const { config } = store.getState((state) => state);
  const requestOptions = config.authorizationHeader
    ? {
        auth() {
          return config.authorizationHeader;
        },
      }
    : {};

  let wadoRsRoot = config.WADO_RS_ENDPOINT;
  let qidoRoot = config.QIDO_RS_ENDPOINT;
  let wadoUriRoot = config.WADO_URI_ENDPOINT;

  const selectedPacs = getSelectedPacsConfig(config);
  if (selectedPacs) {
    wadoRsRoot = selectedPacs.wadoRsUrl;
    qidoRoot = selectedPacs.qidoRsUrl;
    wadoUriRoot = selectedPacs.wadoUriUrl || '';
  }

  return {
    wadoRoot: wadoRsRoot,
    wadoUriRoot,
    qidoRoot,
    qidoSupportsIncludeField: false,
    imageRendering: 'wadors',
    thumbnailRendering: 'wadors',
    enableStudyLazyLoad: lazy,
    requestOptions,
  };
}

const getWadoUri = (wadoURL) => {
  if (wadoURL.includes(RAIMV7_PREFIX)) {
    return `${wadoURL}`.replace(RAIMV7_PREFIX, WADO_RS_PREFIX);
  }
  return `wadouri:${wadoURL}`;
};

const getServerType = (wadoURL) => {
  if (!wadoURL) {
    return DCM4CHEE_SERVER_TYPE;
  }
  if (!wadoURL.includes(RAIMV7_PREFIX)) {
    return DCM4CHEE_SERVER_TYPE;
  }
  return RAIMV7_SERVER_TYPE;
};

const getSkipFetchOverlayData = () => {
  const { config } = store.getState();

  return config.SKIP_FETCH_OVERLAY_DATA || false;
};

export const getAvailableServers = (serverConfig, lazy) => {
  // for each qido, return one config
  if (Array.isArray(serverConfig.wadoRoot)) {
    return serverConfig.wadoRoot.map((wadoRoot, i) => ({
      ...serverConfig,
      serverType: getServerType(serverConfig.wadoUriRoot[i]),
      qidoRoot: serverConfig.qidoRoot[i],
      wadoRoot,
      wadoUriRoot: getWadoUri(serverConfig.wadoUriRoot[i]),
      enableStudyLazyLoad: lazy,
      skipFetchOverlayData: getSkipFetchOverlayData(),
      serverIndex: i
    }));
  }
  return [{
    ...serverConfig,
    wadoUriRoot: `wadouri:${serverConfig.wadoUriRoot}`,
    serverType: getServerType(serverConfig.wadoUriRoot),
    enableStudyLazyLoad: lazy,
    skipFetchOverlayData: getSkipFetchOverlayData(),
    serverIndex: 0
  }];
};

export const cleanPrefix = (uri) => uri.replace(DICOMWEB_PREFIX, '').replace(RAIMV7_PREFIX, '').replace(MY_WADO_RS_PREFIX, '').replace(MY_WADO_URI_PREFIX, '').replace(WADO_RS_PREFIX, '').replace(WADO_URI_PREFIX, '');
